import { render, staticRenderFns } from "./BirthdayListEdit.vue?vue&type=template&id=124bb925&"
import script from "./BirthdayListEdit.vue?vue&type=script&lang=js&"
export * from "./BirthdayListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports